export const DATE_REQUEST_FORMAT = 'YYYY-MM-DD';
